import {
  InvitationMode,
  TransactionType,
} from "@/type/core/transaction/transaction.types";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import DuplicateIcon from "@static/core/icons/icon-duplicate.svg?react";
import EditIcon from "@static/core/icons/icon-edit.svg?react";
import SealFileIcon from "@static/core/icons/icon-seal-file.svg?react";
import SignatureFileIcon from "@static/core/icons/icon-signature-file.svg?react";
import { Signatory } from "@type/core/dashboard/dashboard.types";
import { ModelTransaction } from "@type/core/models/models.types";
import { ColumnsType } from "antd/lib/table/interface";
import i18n from "i18next";

export const columns = (
  setTransactionToEdit: (modelTransaction: ModelTransaction) => void,
  setIsModelToDelete: (modelTransactionId: string) => void,
  setTransactionToDuplicate: (
    modelTransactionId: string,
    modelPreviousName: string,
  ) => void,
): ColumnsType<ModelTransaction> => [
  {
    title: i18n.t("offices.transactionModel.headers.name"),
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
    showSorterTooltip: true,
  },
  {
    title: i18n.t("offices.transactionModel.headers.transactionType"),
    dataIndex: "transactionType",
    render: (transactionType: TransactionType) => {
      return transactionType === "scellement" ? (
        <SealFileIcon className="icon-30" />
      ) : (
        <SignatureFileIcon className="icon-30" />
      );
    },
  },
  {
    title: i18n.t("offices.transactionModel.headers.documents"),
    dataIndex: "documents",
    render: (documents: { name: string }[]) => {
      return (
        <ul className="list-unstyled m-0">
          {documents &&
            documents.map((document, index) => (
              <li
                key={index}
                className="position-relative overflow-ellipsis mb-0"
              >
                {document.name}
              </li>
            ))}
        </ul>
      );
    },
  },
  {
    title: i18n.t("offices.transactionModel.headers.attachments"),
    dataIndex: "attachments",
    render: (attachments: { name: string }[]) => {
      return (
        <ul className="list-unstyled m-0">
          {attachments &&
            attachments.map((attachment, index) => (
              <li
                key={index}
                className="position-relative overflow-ellipsis mb-0"
              >
                {attachment.name}
              </li>
            ))}
        </ul>
      );
    },
  },
  {
    title: i18n.t("offices.transactionModel.headers.signatories"),
    dataIndex: "signatories",
    render: (signatories: Signatory[]) => {
      return (
        <ul className="list-unstyled m-0">
          {signatories &&
            signatories.map((signatory, index) => (
              <li
                key={index}
                className="position-relative overflow-ellipsis mb-0"
              >
                {signatory.firstname} {signatory.lastname}
              </li>
            ))}
        </ul>
      );
    },
  },
  {
    title: i18n.t("offices.transactionModel.headers.invitationMode"),
    dataIndex: "invitationMode",
    render: (invitationMode: InvitationMode) => {
      return invitationMode && invitationMode === "sequential" ? (
        <>{i18n.t("offices.transactionModel.invitationMode.sequential")}</>
      ) : invitationMode && invitationMode === "parallel" ? (
        <>{i18n.t("offices.transactionModel.invitationMode.parallel")}</>
      ) : (
        <></>
      );
    },
  },
  {
    dataIndex: "transactionType",
    width: 162,
    render: (
      _transactionType: TransactionType,
      modelTransaction: ModelTransaction,
    ) => {
      return (
        <div className="d-flex align-items-center justify-content-center gap-24">
          <EditIcon
            onClick={() => setTransactionToEdit(modelTransaction)}
            className="picto icon-30"
          />
          <DeleteIcon
            className="picto icon-30"
            onClick={() => setIsModelToDelete(modelTransaction.id)}
          />
          <DuplicateIcon
            onClick={() =>
              setTransactionToDuplicate(
                modelTransaction.id,
                modelTransaction.name,
              )
            }
            className="picto icon-30"
          />
        </div>
      );
    },
  },
];
